import { authenticationReducer } from '@modules/auth/store/auth-reducer';
import { companyProfileReducer } from '@modules/company-profile/store/company-profile.reducer';
import { omcRegistrationReducer } from '@modules/registration/omc-registration/store/omc-registration.reducer';
import { registrationReducer } from '@modules/registration/store/registration.reducer';
import { supplierRegistrationReducer } from '@modules/registration/supplier-registration/store/supplier-registration.reducer';
import { supplierDashboardReducer } from '@modules/external-services/supplier-management/store/supplier-dashboard.reducer';
import { attachmentTypeFeature } from './store/attachment-types/attachment-types.reducer';

import { registrationAttachmentTypeFeature } from './store/registration-attachment-types/registration-attachment-types.reducer';
import { companyManagementReducer } from '@modules/external-services/company-management/store/company-management.reducers';
import { externalAuthReducer } from '@layouts/external-authenticated-layout/store/external-auth.reducer';
import { workflowReducer } from '@modules/workflow/store/workflow.reducer';
import { financeManagementReducer } from '@modules/external-services/finance-management/store/finance-management.reducers';
import { bankDetailsFeature } from './store/bank-details/bank-details.reducer';
import { FinanceManagementEffects } from '@modules/external-services/finance-management/store/finance-management.effects';
import { productUsageFeature } from '@modules/products/store/product-usage.reducer';
import { productFeature } from '@modules/products/store/product.reducer';
import { productCategoryFeature } from '@modules/products/store/product-category.reducer';
import { financialSecurityReducer } from '@modules/financial-security-configuration/store/financial-security-configuration.reducers';
import { terminalRegistrationReducer } from '@modules/registration/terminal-registration/store/terminal-registration.reducer';
import { terminalOperatorsReducer } from '@modules/terminal-operators/store/terminal-operators.reducers';
import { financialYearFeature } from './store/financial-year/financial-year.reducer';
import { portsFeature } from './store/ports/ports.reducer';
import { demandCyclesFeature } from './store/demand-cycles/demand-cycles.reducer';
import { terminalOperatorManagementReducer } from '@modules/external-services/terminal-operator-management/store/terminal-operator-management.reducers';
import { omcManagementReducer } from '@modules/external-services/omc-management/store/omc-management.reducer';
import { referenceDataFeature } from '@modules/planning/store/reference-data.reducer';
import { nonBpsRegistrationReducer } from '@modules/registration/non-bps-registration/store/non-bps-registration.reducer';
import { nonBpsManagementReducer } from '@modules/external-services/non-bps-management/store/non-bps-management.reducer';
import { consigneesReducer } from './store/consignees/consignees.reducer';
import { smartForecastingReducer } from '@modules/smart-forecasting/store/smart-forecasting.reducer';
import { tankersLineUpFeature } from '@modules/external-services/reports/store/tankers-line-up.reducer';
import { serviceSelectionNotificationsReducer } from '@modules/service-selection/store/service-selection-notifications.reducer';
import { agentTypesReducer } from '@modules/settings/agent-types/store/agent-types.reducers';
import { shippingAgentRegistrationReducer } from '@modules/registration/shipping-agent-registration/store/shipping-agent-registration.reducer';
import { agentApplicationsReducer } from '@modules/applications/agent-applications/store/agent-applications.reducer';
import { shippingAgentManagementReducer } from '@modules/external-services/shipping-agent-management/store/shipping-agent-management.reducer';
import { vesselNominationReducer } from '@modules/applications/vessel-nominations/store/vessel-nomination.reducer';
import { privateTransitCargoReducer } from '@modules/external-services/supplier-management/private-transit-cargo/store/private-transit-cargo.reducer';

export const reducers = {
  authentication: authenticationReducer,
  serviceSelectionNotifications: serviceSelectionNotificationsReducer,
  registration: registrationReducer,
  terminalOperators: terminalOperatorsReducer,
  terminalRegistration: terminalRegistrationReducer,
  companyProfile: companyProfileReducer,
  omcRegistration: omcRegistrationReducer,
  supplierRegistration: supplierRegistrationReducer,
  nonBpsRegistration: nonBpsRegistrationReducer,
  nonBpsManagement: nonBpsManagementReducer,
  shippingAgentRegistration: shippingAgentRegistrationReducer,
  shippingAgentManagement: shippingAgentManagementReducer,
  vesselNomination: vesselNominationReducer,
  privateTransitCargo: privateTransitCargoReducer,
  agentApplications: agentApplicationsReducer,
  consignees: consigneesReducer,
  supplierDashboard: supplierDashboardReducer,
  companyManagement: companyManagementReducer,
  financeManagement: financeManagementReducer,
  omcManagement: omcManagementReducer,
  terminalOperatorManagement: terminalOperatorManagementReducer,
  financialSecurity: financialSecurityReducer,
  externalAuth: externalAuthReducer,
  attachmentTypes: attachmentTypeFeature.reducer,
  registrationAttachmentTypes: registrationAttachmentTypeFeature.reducer,
  bankDetails: bankDetailsFeature.reducer,
  workflow: workflowReducer,
  productUsage: productUsageFeature.reducer,
  product: productFeature.reducer,
  productCategory: productCategoryFeature.reducer,
  financialYear: financialYearFeature.reducer,
  ports: portsFeature.reducer,
  demandCycles: demandCyclesFeature.reducer,
  referenceData: referenceDataFeature.reducer,
  smartForecasting: smartForecastingReducer,
  tankersLineUp: tankersLineUpFeature.reducer,
  agentTypes: agentTypesReducer,
};

